import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import CompanyIcon from './CompanyIcon';
import { HeaderContainer, ViewSettingContainer } from './styled';

const { Text, Flex } = Common;

interface HeaderProps {
  symbol: string;
  name: string;
}

const Header = ({
  symbol,
  name,
}: HeaderProps) => (
  <HeaderContainer>
    <CompanyIcon symbol={symbol} />
    <div>
      <Flex align="center" style={{ gap: 5 }}>
        <Text weight="bold">{symbol}</Text>
        <Text
          size="12px"
          color="#858585"
        >
          {name}
        </Text>
      </Flex>
      <ViewSettingContainer>
        <Image src="/icon/notes/notes-eyes-off.svg" />
        <Text size="11px" color="#858585">
          Only you can see this
        </Text>
      </ViewSettingContainer>
    </div>
  </HeaderContainer>
);

export default Header;
